import React, { Component} from 'react'

class Loading extends Component {
    render() {        
        return <div className="loading-wrap">
            <span className="loading-wrap__spinner"></span>
            Laddar ...            
        </div>
    }
}

export default Loading
